var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-select", {
    ref: "watchlistSelect",
    attrs: {
      value: _vm.searchword,
      "use-input": "",
      "hide-selected": "",
      "fill-input": "",
      "input-debounce": "500",
      label: _vm.$t("label.watchlist"),
      options: _vm.watchlists,
      "option-label": "name",
      loading: _vm.loading,
      disable: _vm.disable
    },
    on: {
      input: _vm.selectWatchlist,
      "update:options": function($event) {
        _vm.watchlists = $event
      },
      filter: _vm.filterWatchlists
    },
    scopedSlots: _vm._u([
      {
        key: "no-option",
        fn: function(scope) {
          return [
            _c("div", { staticClass: "q-pa-md" }, [
              _vm._v(_vm._s(_vm.$t("noResults")))
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }